import { Controller } from "@hotwired/stimulus"

// Polls a Turbo Frame by setting its src at a regular interval to trigger a reload.
// Use with: data-controller="polling" data-polling-interval-value="15000" data-polling-url-value="/path"
// The response frame must NOT have src (per Turbo docs) to avoid circular reference.
// Pauses when the page is hidden (visibility API).
export default class extends Controller {
  static values = { interval: { type: Number, default: 15000 }, url: String }

  connect() {
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.poll()
    this.intervalId = setInterval(() => {
      if (document.visibilityState === "visible") {
        this.poll()
      }
    }, this.intervalValue)
  }

  stopPolling() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  poll() {
    const frame = this.element.querySelector("turbo-frame#sync-status")
    const url = this.urlValue
    if (frame && url) {
      frame.src = url
    }
  }
}
